module.exports = __webpack_public_path__ + "static/media/giraffe.0aa98fd0.png";